import { Component } from "@angular/core";
import { AbstractControl, FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subscription } from "rxjs";
import { Rack } from "src/services/item/rack.interface";
import { BaseFormObjectComponent } from "../base-form-object.component";
import { isItemDimension, ItemDimension, itemDimensionToString } from "src/services/item/item.interface";
import { dimensionFormField } from "./dimension-form-field.form";
import { getDimensionUnitOptions, getWeightUnitOptions } from "src/services/item/item.utils";
import { isNumberValidator } from "src/services/utils/form.validators";

@Component({
  selector: "rc-dimension-form-field",
  templateUrl: "./dimension-form-field.component.html",
  styleUrls: ["./dimension-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DimensionFormFieldComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DimensionFormFieldComponent,
    },
  ],
  standalone: false,
})
export class DimensionFormFieldComponent extends BaseFormObjectComponent<ItemDimension> {
  public onChangeSubs: Subscription[] = [];
  public form = this.formBuilder.group({
    [dimensionFormField.dimensionUnit]: null,
    [dimensionFormField.height]: ["", [isNumberValidator]],
    [dimensionFormField.length]: ["", [isNumberValidator]],
    [dimensionFormField.weight]: ["", [isNumberValidator]],
    [dimensionFormField.weightUnit]: null,
    [dimensionFormField.width]: ["", [isNumberValidator]],
  });

  public constructor(private readonly formBuilder: FormBuilder) {
    super();
  }

  public rackRequiredValidator(control: AbstractControl) {
    const rack = control.value as Rack;

    const values = [rack?.bay, rack?.row, rack?.number];

    if (values.every((x) => !!x) || values.every((x) => !x)) {
      return null;
    } else {
      return { rackIncomplete: true };
    }
  }

  public async onInputChange(event: Partial<ItemDimension>): Promise<void> {
    if (!event || !isItemDimension(event)) {
      return;
    }

    await super.onInputChange(event);
  }

  public validate(control: AbstractControl): object | null {
    return this.rackRequiredValidator(control);
  }

  protected toDisplayValue(input: ItemDimension): string {
    return itemDimensionToString(input);
  }

  public readonly dimensionFormField = dimensionFormField;
  public readonly getDimensionUnitOptions = getDimensionUnitOptions;
  public readonly getWeightUnitOptions = getWeightUnitOptions;
}
